export default "__VITE_ASSET__d921f5a6__"